<template>
	<component
		:is="type"
		:data="updatedDetails"
		:source="source"
		:downloadsource="downloadsource"
		:class="gtmClassName"
	/>
</template>

<script>
import Panel from "../../../components/AppPanel";
import apexchart from "../../ApexCharts";
import chart from "../../Graphs/Chart";
import downloadable from "../components/Downloadable";
import score from "../components/Score";
import progressbar from "../components/ProgressBar";
import split from "../components/Split";
import textual from "../components/Textual";
import rowtitle from "../components/Title";
import tabular from "../components/Table";
import locations from "../components/LocationMap";
import { mapGetters } from "vuex";
import { sourcePath } from "../../utils";

export default {
	components: {
		apexchart,
		chart,
		downloadable,
		Panel,
		score,
		progressbar,
		split,
		textual,
		rowtitle,
		tabular,
		locations
	},
	props: {
		details: {
			type: Object,
			default: () => null
		},
		hospitalId: {
			type: Number,
			default: () => null
		},
		listingId: {
			type: Number,
			default: () => null
		},
		organisationId: {
			type: Number,
			default: () => null
		}
	},
	computed: {
		...mapGetters({
			query: "reportQueries/query"
		}),
		heading() {
			return this.details.title;
		},
		gtmClassName() {
			return this.details.gtmclass || null;
		},
		source() {
			if (!this.details.source) {
				return null;
			}

			let source = sourcePath(this.details.source, {
				listingid: this.listingId,
				hospitalid: this.hospitalId,
				organisationid: this.organisationId
			});

			// If the source already has a query string, then change the
			// separator to "&"
			let sep = source.includes("?") ? "&" : "?";
			return `${source}${sep}${this.query}`;
		},
		downloadsource() {
			if (!this.details.downloadsource) {
				return null;
			}

			let source = sourcePath(this.details.downloadsource, {
				listingid: this.listingId,
				hospitalid: this.hospitalId,
				organisationid: this.organisationId
			});

			// If the source already has a query string, then change the
			// separator to "&"
			let sep = source.includes("?") ? "&" : "?";

			return (
				process.env.VUE_APP_SERVICES +
				source +
				sep +
				this.query +
				"&jwt=" +
				window.localStorage.getItem("token")
			);
			// return `${source}${sep}${this.query}`;
		},
		updatedDetails() {
			return {
				...this.details,
				listingid: this.listingId,
				hospitalid: this.hospitalId,
				organisationid: this.organisationId,
				query: this.query
			};
		},
		type() {
			return ["locations", "tabular", "score", "textual", "rowtitle"].includes(
				this.details.type
			)
				? this.details.type
				: "apexchart";
		}
	}
};
</script>

<style>
.column-title {
	min-height: 36px;
	display: flex;
	align-items: flex-start;
	margin-bottom: 1em;
}
</style>
